import { useContext } from 'react';
import { createPortal } from 'react-dom';
import { Chat, useGetChatSocketUrl } from '@namespace/chats';
import { UserContext } from '@namespace/user/src/context';

const SupportChat = () => {
  const chatSocketUrl = useGetChatSocketUrl();
  const [user] = useContext(UserContext);
  const { role, firstName, lastName, id: userId, userInfoLoaded } = user;
  const userInfo =
    role === 'user' ? { name: `${firstName} ${lastName}`, id: userId } : null;

  return (
    userInfoLoaded &&
    createPortal(
      <Chat socketUrl={chatSocketUrl} userInfo={userInfo} showHeader={false} />,
      document.body
    )
  );
};
export default SupportChat;
